import { useEffect, useState } from "react";
import styled from "@emotion/styled";
import InputField, { AsyncMultiSelectField } from "components/auth/InputField";
import {
  useCheckIfTeamExistsLazyQuery,
  useCreateTeamMutation,
} from "generated/graphql";
import { StylesConfig } from "react-select";

const Wrapper = styled.div`
  max-width: 300px;
  padding-top: 1rem;

  .input-box {
    padding: 10px;
    margin-bottom: 1rem;
    margin-top: 0.125rem;
    color: #fff;
  }

  label {
    font-size: 1.25rem;
  }
`;

const teamSizeMap = {
  TEAM_SOLO: 1,
  TEAM_DUOS: 2,
  TEAM_TRIOS: 3,
  TEAM_3v3: 3,
  TEAM_SQUAD: 4,
  TEAM_5v5: 5,
};

function NewTeamRegistration({
  name,
  displayName,
  avatar,
  teamMembers,
  updateFunctions,
  searchGamers,
  teamType,
  handleSubmit,
  isLoading = false,
  isSubmitting,
}: {
  name?: string;
  displayName?: string;
  avatar?: string;
  teamType?: string;
  teamMembers: string[];
  updateFunctions: {
    setTeamName: Function;
    setDisplayName: Function;
    setAvatar: Function;
    setTeamMembers: Function;
  };
  searchGamers: Function;
  handleSubmit: any;
  isLoading: boolean;
  isSubmitting: boolean;
}) {
  const [section] = useState("section-1");
  const [checkIfTeamExists, { loading, data, error }] =
    useCheckIfTeamExistsLazyQuery();
  // @ts-ignore
  const maxMembers = teamSizeMap[teamType!];

  const [createTeamMutation] = useCreateTeamMutation();

  useEffect(() => {
    if (teamType) {
      checkIfTeamExists({
        variables: {
          input: {
            name: name!,
            nickname: displayName!,
            teamType: teamType!,
          },
        },
      });
    }
  }, [name, displayName, checkIfTeamExists, teamType]);

  const styles: StylesConfig<any, true> = {
    multiValue: (base, state) => {
      return state.data.isFixed ? { ...base, backgroundColor: "gray" } : base;
    },
    multiValueLabel: (base, state) => {
      return state.data.isFixed
        ? { ...base, fontWeight: "bold", color: "white", paddingRight: 6 }
        : base;
    },
    multiValueRemove: (base, state) => {
      return state.data.isFixed ? { ...base, display: "none" } : base;
    },
  };

  const onSubmit = async () => {
    if (data?.checkIfTeamExists?.type === "ERROR") {
      return;
    }
    const result = await createTeamMutation({
      variables: {
        input: {
          avatar,
          locale: "Kenya",
          location: "Kenya",
          name: name!,
          nickname: displayName!,
          // @ts-ignore
          ownerId: teamMembers[0].id,
          // @ts-ignore
          teamMembers: teamMembers.map((member) => member.value),
          teamType: teamType!,
        },
      },
    });
    if (result.data?.createTeam) {
      await handleSubmit(result.data.createTeam.teamId);
    }
  };

  // @ts-ignore
  const teamMembersNeeded = teamSizeMap[teamType] - teamMembers.length;
  let teamMembersLabel = `Find ${teamMembersNeeded} more team member${
    teamMembersNeeded > 1 ? "s" : ""
  }`;
  teamMembersLabel =
    teamMembersNeeded === 0 ? `You're all set to go!` : teamMembersLabel;

  const canSubmit = teamMembersNeeded === 0 && !!name && !!displayName;

  return (
    <Wrapper style={{ margin: "auto", maxWidth: "350px" }}>
      {section === "section-1" && (
        <>
          {/* <SelectField
            setValue={updateFunctions["setTeamType"]}
            value={teamType}
            label="Team type"
          /> */}
          <InputField
            setValue={updateFunctions["setTeamName"]}
            value={name}
            placeholder="Enter team name"
            type="text"
            name="name"
            label="Official team name"
            className="input-box"
          />
          <InputField
            setValue={updateFunctions["setDisplayName"]}
            value={displayName}
            placeholder="Enter display name"
            type="text"
            name="displayName"
            label="Team display name"
            className="input-box"
          />
          {!loading &&
            !error &&
            data &&
            data.checkIfTeamExists?.type === "ERROR" && (
              <b style={{ color: "red" }}>
                A team with these details already exists <br />
              </b>
            )}
          {/* <InputField
            setValue={updateFunctions["setAvatar"]}
            value={avatar}
            placeholder="Enter team avatar URL"
            type="text"
            name="avatar"
            label="Team Avatar URL"
            className="input-box"
          /> */}
          <AsyncMultiSelectField
            setValue={updateFunctions["setTeamMembers"]}
            value={teamMembers}
            placeholder="Search team members"
            type="text"
            name="teamMembers"
            label={teamMembersLabel}
            loadingMessage="Searching..."
            noOptionsMessage="No results found"
            isLoading={isLoading}
            maxSelection={maxMembers}
            styles={styles}
            loadOptions={async (inputValue: string, callback: any) => {
              const res = await searchGamers(inputValue);
              if (res) {
                callback(res);
              }
            }}
          />
        </>
      )}
      <div style={{ display: "flex" }}>
        <button
          onClick={() => onSubmit()}
          disabled={isSubmitting || !canSubmit}
          className="btn"
        >
          Register team
        </button>
      </div>
    </Wrapper>
  );
}

export default NewTeamRegistration;
